// extracted by mini-css-extract-plugin
export default {"storeIconWrapper":"styles_storeIconWrapper__r8Pyl","title":"styles_title__Q3PB7","active":"styles_active__SJjC9"};